import { useReveal } from "../../lib/useReveal";

const items = [
    {
        no: "I.",
        title: "Não entregamos leads para terceiros venderem.",
        body: "Quem gera demanda e quem fecha precisam estar sob o mesmo controle. Aquisição desconectada de conversão é desperdício estruturado.",
    },
    {
        no: "II.",
        title: "Não operamos marketing tradicional.",
        body: "Não somos pagos para produzir posts, criativos ou relatórios. Somos remunerados quando o caixa do cliente cresce.",
    },
    {
        no: "III.",
        title: "Não trabalhamos com vaidade digital.",
        body: "Engajamento, alcance e impressões não pagam folha. Receita paga. Tudo o que medimos converge para fechamento.",
    },
    {
        no: "IV.",
        title: "Aquisição e conversão são uma só operação.",
        body: "Tratamos pipeline, abordagem, oferta, follow-up e fechamento como engrenagens da mesma máquina. Nada é terceirizado.",
    },
];

export default function NaoSomosAgencia() {
    const ref = useReveal();
    return (
        <section
            data-testid="nao-somos-agencia"
            id="nao-somos-agencia"
            className="relative py-28 lg:py-40 border-t border-white/5"
        >
            <div ref={ref} className="reveal max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
                        <div className="flex items-center gap-4 mb-8">
                            <span className="h-px w-10 bg-[#d4af37]" />
                            <span className="tag-fluxo">Posicionamento</span>
                        </div>
                        <h2 className="font-['Outfit'] font-bold uppercase tracking-[-0.02em] text-4xl md:text-5xl lg:text-[64px] leading-[0.95]">
                            <span className="text-white/30 line-through decoration-[#d4af37]/40 decoration-1">
                                Agência
                            </span>
                            <br />
                            <span className="text-white">de marketing.</span>
                        </h2>
                        <p className="mt-8 text-white/60 text-base leading-relaxed max-w-md">
                            Operamos um modelo diferente. Mais raro. Mais
                            comprometido. Mais alinhado.
                        </p>
                    </div>

                    <div className="lg:col-span-7 space-y-px">
                        {items.map((it, i) => (
                            <div
                                key={i}
                                data-testid={`nao-somos-item-${i}`}
                                className="group border-t border-white/5 last:border-b py-8 grid grid-cols-12 gap-6 transition-all hover:bg-[#0e0e0e]"
                            >
                                <div className="col-span-2 sm:col-span-1 text-[#d4af37] font-['Outfit'] font-light text-xl">
                                    {it.no}
                                </div>
                                <div className="col-span-10 sm:col-span-11">
                                    <h3 className="text-white font-['Outfit'] font-medium text-xl md:text-2xl leading-snug">
                                        {it.title}
                                    </h3>
                                    <p className="mt-3 text-white/55 leading-relaxed text-sm md:text-base max-w-2xl">
                                        {it.body}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
